import CustomModal from "../CustomModal";

const NotificationSuccessModal = ({
  isOpen,
  onRequestClose,
  title,
  onClose,
  shouldReload = false,
}) => {
  const handleClose = () => {
    onRequestClose();
    if (onClose) onClose();
    if (shouldReload) {
      window.location.reload();
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="edit-success-modal"
      contentLabel="Success"
    >
      <img src={`${process.env.PUBLIC_URL}/images/thumbs-up.png`} alt="Success" />
      <h2 style={{ fontWeight: "bold" }}>{title}</h2>
      <button onClick={handleClose}>Close</button>
    </CustomModal>
  );
};

export default NotificationSuccessModal;
